import React from "react";
import styles from "./Icon.module.css";

const Icon = ({ icon, square = false, color, className = "", size, ...props }) => {
  const classes = [
    styles.iconWrapper,
    square && styles.square,
    size && styles[size],
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const fill =
    props.fill ||
    (color === "yellow"
      ? "var(--yellow)"
      : color === "black"
        ? "var(--color-text)"
        : color === "white"
          ? "var(--white)"
          : null);

  return (
    <div
      className={classes}
      style={{
        backgroundColor: square
          ? color !== "white"
            ? "var(--white)"
            : "var(--yellow)"
          : "",
      }}
      {...props}
    >
      {icons[icon]({ fill })}
    </div>
  );
};

const icons = {
  dashboard: ({ fill }) => (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1870_578)">
        <path
          d="M8.99216 4.15472C8.94138 4.10615 8.87382 4.07904 8.80356 4.07904C8.73329 4.07904 8.66573 4.10615 8.61496 4.15472L2.33624 10.1528C2.30957 10.1783 2.28836 10.2089 2.27388 10.2429C2.2594 10.2768 2.25196 10.3133 2.252 10.3502L2.25098 15.9796C2.25098 16.269 2.36596 16.5466 2.57063 16.7513C2.7753 16.956 3.05289 17.0709 3.34233 17.0709H6.61982C6.76454 17.0709 6.90334 17.0134 7.00567 16.9111C7.108 16.8088 7.1655 16.67 7.1655 16.5253V11.887C7.1655 11.8146 7.19424 11.7452 7.24541 11.6941C7.29658 11.6429 7.36597 11.6141 7.43834 11.6141H10.1667C10.2391 11.6141 10.3085 11.6429 10.3597 11.6941C10.4108 11.7452 10.4396 11.8146 10.4396 11.887V16.5253C10.4396 16.67 10.4971 16.8088 10.5994 16.9111C10.7017 17.0134 10.8405 17.0709 10.9852 17.0709H14.2614C14.5508 17.0709 14.8284 16.956 15.0331 16.7513C15.2377 16.5466 15.3527 16.269 15.3527 15.9796V10.3502C15.3528 10.3133 15.3453 10.2768 15.3308 10.2429C15.3164 10.2089 15.2952 10.1783 15.2685 10.1528L8.99216 4.15472Z"
          fill={fill}
        />
        <path
          d="M16.8149 9.0279L14.2639 6.58735V2.8839C14.2639 2.73918 14.2064 2.60038 14.1041 2.49805C14.0017 2.39571 13.8629 2.33822 13.7182 2.33822H12.0812C11.9365 2.33822 11.7977 2.39571 11.6953 2.49805C11.593 2.60038 11.5355 2.73918 11.5355 2.8839V3.97526L9.56014 2.08653C9.3753 1.89963 9.10041 1.79254 8.80336 1.79254C8.50733 1.79254 8.23312 1.89963 8.04827 2.08687L0.794158 9.02722C0.582026 9.23185 0.555424 9.56846 0.748458 9.79015C0.796931 9.8461 0.856284 9.89161 0.922904 9.9239C0.989524 9.95619 1.06202 9.97458 1.13597 9.97796C1.20993 9.98135 1.2838 9.96964 1.35308 9.94357C1.42237 9.9175 1.48563 9.8776 1.53901 9.8263L8.61578 3.06397C8.66656 3.0154 8.73411 2.98829 8.80438 2.98829C8.87465 2.98829 8.9422 3.0154 8.99298 3.06397L16.0704 9.8263C16.1747 9.92628 16.3143 9.98084 16.4587 9.97803C16.6032 9.97521 16.7406 9.91525 16.8409 9.81129C17.0503 9.59438 17.0329 9.23628 16.8149 9.0279Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_1870_578">
          <rect
            width="17.4617"
            height="17.4617"
            fill={fill}
            transform="translate(0.0717773 0.700195)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  team: ({ fill }) => {
    const person = (
      <>
        <path
          d="M12.0758 2.84969C11.4121 2.13315 10.4851 1.73856 9.46198 1.73856C8.43338 1.73856 7.50334 2.13076 6.84273 2.84287C6.17495 3.56283 5.84959 4.5413 5.92599 5.59787C6.07741 7.68236 7.66363 9.37806 9.46198 9.37806C11.2603 9.37806 12.8438 7.6827 12.9976 5.59855C13.0751 4.55153 12.7477 3.57511 12.0758 2.84969Z"
          fill={fill}
        />
        <path
          d="M15.4642 17.0168H3.45923C3.30209 17.0188 3.14648 16.9858 3.00371 16.9201C2.86094 16.8545 2.7346 16.7578 2.63389 16.6372C2.41221 16.3722 2.32285 16.0103 2.38902 15.6444C2.67686 14.0476 3.57518 12.7063 4.98713 11.7646C6.24151 10.9287 7.83045 10.4686 9.46169 10.4686C11.0929 10.4686 12.6819 10.929 13.9363 11.7646C15.3482 12.7059 16.2465 14.0473 16.5344 15.6441C16.6005 16.01 16.5112 16.3718 16.2895 16.6368C16.1888 16.7575 16.0625 16.8543 15.9197 16.92C15.7769 16.9857 15.6213 17.0188 15.4642 17.0168V17.0168Z"
          fill={fill}
        />
      </>
    );

    const outline = fill === "var(--white)" ? "var(--yellow)" : "var(--white)";

    return (
      <svg
        width="19"
        height="19"
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g transform="translate(0.15 3.05) scale(0.52)">{person}</g>
        <g transform="translate(8.95 3.05) scale(0.52)">{person}</g>
        <g
          transform="translate(2.15 1.15) scale(0.78)"
          stroke={outline}
          strokeWidth="2.2"
          strokeLinejoin="round"
          style={{ paintOrder: "stroke fill" }}
        >
          {person}
        </g>
      </svg>
    );
  },
  profile: ({ fill }) => (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0758 2.84969C11.4121 2.13315 10.4851 1.73856 9.46198 1.73856C8.43338 1.73856 7.50334 2.13076 6.84273 2.84287C6.17495 3.56283 5.84959 4.5413 5.92599 5.59787C6.07741 7.68236 7.66363 9.37806 9.46198 9.37806C11.2603 9.37806 12.8438 7.6827 12.9976 5.59855C13.0751 4.55153 12.7477 3.57511 12.0758 2.84969Z"
        fill={fill}
      />
      <path
        d="M15.4642 17.0168H3.45923C3.30209 17.0188 3.14648 16.9858 3.00371 16.9201C2.86094 16.8545 2.7346 16.7578 2.63389 16.6372C2.41221 16.3722 2.32285 16.0103 2.38902 15.6444C2.67686 14.0476 3.57518 12.7063 4.98713 11.7646C6.24151 10.9287 7.83045 10.4686 9.46169 10.4686C11.0929 10.4686 12.6819 10.929 13.9363 11.7646C15.3482 12.7059 16.2465 14.0473 16.5344 15.6441C16.6005 16.01 16.5112 16.3718 16.2895 16.6368C16.1888 16.7575 16.0625 16.8543 15.9197 16.92C15.7769 16.9857 15.6213 17.0188 15.4642 17.0168V17.0168Z"
        fill={fill}
      />
    </svg>
  ),
  logout: ({ fill }) => (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.0207 0.815288C16.0144 0.785125 15.9997 0.757362 15.9783 0.735254C15.9569 0.713146 15.9296 0.697608 15.8996 0.690464C13.9021 0.202081 9.28665 1.94246 6.78608 4.442C6.34008 4.8844 5.93349 5.36482 5.57092 5.87782C4.79981 5.80961 4.02869 5.86657 3.37149 6.15305C1.51721 6.96918 0.977326 9.09869 0.826924 10.0147C0.818393 10.0649 0.821611 10.1163 0.836324 10.165C0.851038 10.2137 0.876847 10.2583 0.91172 10.2953C0.946593 10.3323 0.98958 10.3608 1.0373 10.3784C1.08502 10.396 1.13617 10.4022 1.18673 10.3967L4.16443 10.0683C4.16656 10.2928 4.1801 10.517 4.20502 10.7402C4.22 10.8951 4.28878 11.0399 4.39941 11.1494L5.5525 12.2998C5.66211 12.4103 5.80686 12.479 5.96176 12.4942C6.18364 12.519 6.40663 12.5325 6.62988 12.5348L6.30315 15.5087C6.2977 15.5593 6.30403 15.6104 6.32165 15.6581C6.33927 15.7057 6.3677 15.7487 6.4047 15.7836C6.44171 15.8184 6.48629 15.8442 6.53494 15.859C6.58359 15.8737 6.635 15.877 6.68513 15.8685C7.59948 15.7219 9.73274 15.182 10.5441 13.3277C10.8306 12.6705 10.8892 11.9031 10.8231 11.1358C11.3373 10.7732 11.819 10.3665 12.2626 9.92028C14.7711 7.42448 16.5015 2.91206 16.0207 0.815288ZM9.76002 6.94292C9.53097 6.71402 9.37496 6.42233 9.3117 6.10474C9.24845 5.78716 9.28081 5.45795 9.40468 5.15876C9.52855 4.85957 9.73837 4.60384 10.0076 4.42391C10.2768 4.24398 10.5934 4.14794 10.9172 4.14794C11.241 4.14794 11.5576 4.24398 11.8268 4.42391C12.096 4.60384 12.3059 4.85957 12.4297 5.15876C12.5536 5.45795 12.586 5.78716 12.5227 6.10474C12.4595 6.42233 12.3034 6.71402 12.0744 6.94292C11.9225 7.09502 11.7421 7.21569 11.5436 7.29802C11.345 7.38035 11.1322 7.42272 10.9172 7.42272C10.7023 7.42272 10.4894 7.38035 10.2909 7.29802C10.0923 7.21569 9.91191 7.09502 9.76002 6.94292Z"
        fill={fill}
      />
    </svg>
  ),
  search: ({ fill }) => (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3791 12.8458L10.6226 10.0893C11.2862 9.2058 11.6445 8.13041 11.6433 7.02542C11.6433 4.20297 9.34697 1.90668 6.52451 1.90668C3.70205 1.90668 1.40576 4.20297 1.40576 7.02542C1.40576 9.84788 3.70205 12.1442 6.52451 12.1442C7.62949 12.1454 8.70488 11.7871 9.58838 11.1235L12.3449 13.88C12.4845 14.0047 12.6664 14.0713 12.8535 14.0661C13.0406 14.0609 13.2186 13.9842 13.3509 13.8519C13.4833 13.7195 13.5599 13.5415 13.5652 13.3544C13.5704 13.1674 13.5038 12.9854 13.3791 12.8458ZM2.86826 7.02542C2.86826 6.30229 3.0827 5.59539 3.48445 4.99412C3.8862 4.39286 4.45723 3.92422 5.12532 3.64749C5.79342 3.37076 6.52857 3.29835 7.23781 3.43943C7.94705 3.58051 8.59853 3.92873 9.10987 4.44007C9.6212 4.9514 9.96943 5.60288 10.1105 6.31213C10.2516 7.02137 10.1792 7.75652 9.90244 8.42461C9.62571 9.0927 9.15708 9.66373 8.55581 10.0655C7.95455 10.4672 7.24765 10.6817 6.52451 10.6817C5.55517 10.6805 4.62586 10.2949 3.94044 9.6095C3.25501 8.92407 2.86942 7.99477 2.86826 7.02542Z"
        fill="#808080"
        fillOpacity="0.55"
      />
    </svg>
  ),
  edit: ({ fill }) => (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1605_285)">
        <path
          d="M1.875 10.9125V12.8125C1.875 12.9875 2.0125 13.125 2.1875 13.125H4.0875C4.16875 13.125 4.25 13.0938 4.30625 13.0313L11.1312 6.21251L8.7875 3.86876L1.96875 10.6875C1.90625 10.75 1.875 10.825 1.875 10.9125ZM12.9437 4.40001C13.1875 4.15626 13.1875 3.76251 12.9437 3.51876L11.4813 2.05626C11.2375 1.81251 10.8437 1.81251 10.6 2.05626L9.45625 3.20001L11.8 5.54376L12.9437 4.40001Z"
          fill={fill || "#2D3748"}
        />
      </g>
      <defs>
        <clipPath id="clip0_1605_285">
          <rect width="15" height="15" fill={fill} />
        </clipPath>
      </defs>
    </svg>
  ),
  mail: ({ fill }) => (
    <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M256 352c-16.53 0-33.06-5.422-47.16-16.41L0 173.2V400C0 426.5 21.49 448 48 448h416c26.51 0 48-21.49 48-48V173.2l-208.8 162.5C289.1 346.6 272.5 352 256 352zM16.29 145.3l212.2 165.1c16.19 12.6 38.87 12.6 55.06 0l212.2-165.1C505.1 137.3 512 125 512 112C512 85.49 490.5 64 464 64h-416C21.49 64 0 85.49 0 112C0 125 6.01 137.3 16.29 145.3z"
        fill={fill}
      />
    </svg>
  ),
  "sayn-logo": ({ fill }) => (
    <svg
      width="73"
      height="73"
      viewBox="0 0 73 73"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M45.9701 2.16004L45.8901 2.14004V2.13004L46.1301 1.54004L46.1201 1.60004L46.1401 1.54004L46.1701 1.55004L46.1801 1.56004L46.1301 1.66004L45.9701 2.16004Z"
        strokeWidth="1.6"
        stroke={fill}
        fill={fill}
      />
      <path
        d="M36.22 72.1098C25.66 72.1098 15.6701 67.4898 8.81007 59.4398L8.7701 59.3798C6.9801 56.0898 5.84007 52.3998 5.37007 48.4198C4.66007 43.3598 5.10007 38.2998 6.68007 33.3998C7.01007 32.3798 7.41006 31.3598 7.86006 30.3698C9.58006 26.3998 12.4001 22.8798 15.9901 20.1898C23.1301 14.7198 31.0401 13.3298 39.5001 16.0598C40.2401 16.2998 40.98 16.5798 41.72 16.8998L41.5001 17.5098C39.8001 17.0298 38.0401 16.7898 36.2701 16.7898C30.6601 16.7898 25.6601 19.1798 20.9901 24.1098C14.0001 31.4798 11.5001 41.0898 14.3101 49.8098C17.9401 61.0698 29.1101 69.3998 41.4801 70.0698C43.4201 70.1698 45.3501 70.0498 47.2301 69.7098L47.3901 70.3298C43.8101 71.5098 40.04 72.1098 36.22 72.1098ZM9.33009 59.0398C16.0601 66.9298 25.86 71.4598 36.22 71.4598C38.62 71.4598 41.0001 71.2198 43.3301 70.7398C42.7101 70.7498 42.0901 70.7398 41.4601 70.7098C28.8301 70.0298 17.4201 61.5198 13.7101 50.0098C10.8301 41.0598 13.3801 31.2198 20.5301 23.6698C25.3301 18.6098 30.4801 16.1498 36.2801 16.1498C36.7401 16.1498 37.2101 16.1698 37.6701 16.1998C30.0401 14.2198 22.8901 15.7298 16.3901 20.7098C12.8801 23.3298 10.1401 26.7698 8.4601 30.6398C8.0101 31.6098 7.63006 32.6098 7.30006 33.5998C5.75006 38.4098 5.32009 43.3698 6.01009 48.3398C6.47009 52.2298 7.59009 55.8298 9.33009 59.0398Z"
        strokeWidth="1.6"
        stroke={fill}
        fill={fill}
      />
      <path
        d="M42.8404 70.7501C42.3804 70.7501 41.9204 70.7401 41.4604 70.7101C28.8304 70.0301 17.4204 61.5201 13.7104 50.0101C10.7704 40.8801 13.5104 30.6601 20.8604 23.3501L21.3404 23.7801C21.3104 23.8201 21.2504 23.9201 21.1804 24.0101C21.1104 24.1201 21.0404 24.2201 21.0104 24.2701C18.3504 27.6901 16.9404 31.8001 16.9404 36.1401C16.9404 39.8801 18.0103 43.5201 20.0403 46.6501L20.0604 46.6901C24.2004 55.5101 33.0104 61.1901 42.5104 61.1901C42.5504 61.1901 42.5904 61.1901 42.6304 61.1901C54.4704 61.1301 65.7804 53.0001 70.1504 41.4101C70.8304 39.6101 71.3003 37.7401 71.5403 35.8601L72.1804 35.9001V36.1601C72.1804 43.5301 69.9704 50.6101 65.7804 56.6501C61.6904 62.5401 56.0104 67.0401 49.3604 69.6601C48.7204 69.9101 48.0504 70.1501 47.3904 70.3701L47.3503 70.3801C45.8803 70.6101 44.3704 70.7501 42.8404 70.7501ZM18.4204 27.1601C13.4704 33.8801 11.8904 42.2301 14.3304 49.8101C17.9604 61.0701 29.1304 69.4101 41.5004 70.0701C43.4304 70.1701 45.3503 70.0501 47.2304 69.7101C47.8703 69.5001 48.5204 69.2701 49.1404 69.0201C61.5904 64.1301 70.0104 52.9201 71.3604 39.8501C71.1804 40.4401 70.9904 41.0301 70.7704 41.6101C66.3104 53.4401 54.7504 61.7501 42.6504 61.8101C42.6104 61.8101 42.5704 61.8101 42.5304 61.8101C32.7804 61.8101 23.7604 55.9901 19.5004 46.9601C17.4104 43.7301 16.3104 39.9801 16.3104 36.1201C16.3004 32.9701 17.0304 29.9201 18.4204 27.1601Z"
        strokeWidth="1.6"
        stroke={fill}
        fill={fill}
      />
      <path
        d="M42.5205 61.8198C32.7605 61.8198 23.7305 55.9998 19.4805 46.9498L20.0405 46.6398C20.2305 46.9298 20.4205 47.2098 20.6305 47.4898C24.2605 52.4898 30.1105 55.4698 36.2805 55.4698C38.2105 55.4698 40.1105 55.1898 41.9305 54.6298L41.9705 54.6198C51.5905 53.0998 59.5105 46.2098 62.1505 37.0798C65.4305 25.7098 60.8305 12.5598 50.9405 5.0998C49.3805 3.9198 47.6905 2.92981 45.9205 2.15981L46.1405 1.5498C53.3705 3.6198 59.9205 8.0498 64.5805 14.0098C69.3805 20.1598 72.0105 27.5398 72.1805 35.3498C72.1805 35.5198 72.1905 35.6998 72.1905 35.8698C71.9405 37.8398 71.4605 39.7598 70.7605 41.6098C66.3005 53.4398 54.7405 61.7498 42.6405 61.8098C42.6105 61.8198 42.5605 61.8198 42.5205 61.8198ZM22.0405 50.1398C26.6505 56.9498 34.3305 61.1698 42.5205 61.1698C42.5605 61.1698 42.6005 61.1698 42.6405 61.1698C54.4805 61.1098 65.7905 52.9798 70.1605 41.3898C70.8405 39.5898 71.3105 37.7198 71.5505 35.8398C71.5505 35.7098 71.5405 35.5398 71.5405 35.3698C71.3805 27.6998 68.8005 20.4498 64.0805 14.4098C60.3605 9.6398 55.4005 5.87981 49.8605 3.53981C50.3605 3.86981 50.8605 4.20981 51.3405 4.57981C61.4305 12.1998 66.1405 25.6398 62.7805 37.2598C60.0705 46.6298 51.9605 53.6898 42.1105 55.2598C40.2305 55.8298 38.2705 56.1198 36.2905 56.1198C30.9105 56.1098 25.7705 53.9198 22.0405 50.1398Z"
        strokeWidth="1.6"
        stroke={fill}
        fill={fill}
      />
      <path
        d="M42.09 55.2599L41.95 54.6299C42.19 54.5599 42.42 54.4799 42.65 54.3999C50.41 51.6999 55.63 44.3599 55.63 36.1299V35.8099V35.7899C56.88 26.3399 52.68 16.8999 44.93 11.7399C35.08 5.16993 21.15 5.59992 11.05 12.7599C9.46999 13.8799 8.02001 15.1899 6.76001 16.6299L6.25 16.2399C12.95 6.17992 24.15 0.169922 36.22 0.169922C39.59 0.169922 42.92 0.639923 46.13 1.54992L46.19 1.56992C48.01 2.35992 49.74 3.36992 51.34 4.58992C61.43 12.2099 66.14 25.6499 62.78 37.2699C60.07 46.6299 51.95 53.6899 42.09 55.2599ZM56.27 35.8399V36.1299C56.27 43.5399 52.17 50.2599 45.8 53.7099C53.66 51.1899 59.88 44.9699 62.16 37.0699C65.44 25.6999 60.84 12.5499 50.95 5.08992C49.39 3.90992 47.7 2.91993 45.93 2.14993C42.8 1.25993 39.53 0.799923 36.22 0.799923C25.73 0.799923 15.9 5.41992 9.21997 13.3399C9.68997 12.9499 10.17 12.5799 10.67 12.2299C20.98 4.90992 35.21 4.47992 45.28 11.1999C53.23 16.4899 57.54 26.1599 56.27 35.8399Z"
        strokeWidth="1.6"
        stroke={fill}
        fill={fill}
      />
      <path
        d="M10.8203 61.7898L8.81024 59.4298C8.23024 58.7398 7.66026 58.0298 7.14026 57.3098C2.63026 51.1298 0.240234 43.7998 0.240234 36.1298C0.240234 29.4398 2.09026 22.9198 5.58026 17.2498C5.79026 16.8998 6.01023 16.5598 6.24023 16.2298C7.56023 14.7198 9.04023 13.3798 10.6702 12.2298C20.9802 4.90977 35.2103 4.47978 45.2803 11.1998C53.2303 16.4998 57.5403 26.1798 56.2603 35.8698L55.6202 35.8298V35.6098C55.4002 27.3198 49.9403 20.1098 42.0203 17.6498H42.0002C41.8402 17.5998 41.6803 17.5498 41.5203 17.5098L41.4802 17.4898C40.7702 17.1798 40.0403 16.8998 39.3203 16.6698C31.0703 14.0098 23.3603 15.3698 16.3903 20.6998C12.8803 23.3198 10.1403 26.7598 8.46027 30.6298C8.01027 31.5998 7.63023 32.5998 7.30023 33.5898C5.75023 38.3998 5.32025 43.3598 6.01025 48.3298C6.47025 52.2398 7.59027 55.8498 9.34027 59.0698L10.8203 61.7898ZM29.0203 7.07978C22.7403 7.07978 16.3602 8.97977 11.0502 12.7598C9.47023 13.8798 8.02025 15.1898 6.76025 16.6298C6.57025 16.9298 6.35026 17.2598 6.14026 17.5998C2.71026 23.1598 0.890259 29.5698 0.890259 36.1398C0.890259 43.5898 3.18025 50.6998 7.51025 56.7298C6.44025 54.1498 5.72025 51.3698 5.38025 48.4298C4.67025 43.3698 5.11025 38.3098 6.69025 33.4098C7.02025 32.3898 7.42024 31.3698 7.87024 30.3798C9.59024 26.4098 12.4102 22.8898 16.0002 20.1998C23.1402 14.7298 31.0503 13.3398 39.5103 16.0698C40.2403 16.3098 40.9803 16.5898 41.7103 16.8998C41.8203 16.9298 41.9302 16.9598 42.0402 16.9898L42.0502 16.9598L42.2302 17.0498C49.2202 19.2298 54.3503 24.9898 55.8303 31.9698C55.6703 23.8698 51.6202 16.1998 44.9202 11.7298C40.2602 8.61978 34.6803 7.07978 29.0203 7.07978Z"
        fill={fill}
        stroke={fill}
        strokeWidth="1.6"
      />
    </svg>
  ),
  wallet: ({ fill }) => (
    <svg
      width="27"
      height="26"
      viewBox="0 0 27 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.93285 5.27885H21.1828C21.3727 5.27877 21.5623 5.29081 21.7506 5.31491C21.6868 4.8669 21.5329 4.43646 21.2982 4.04954C21.0635 3.66261 20.7529 3.32722 20.3851 3.06358C20.0173 2.79993 19.5999 2.61351 19.1582 2.51553C18.7164 2.41755 18.2593 2.41006 17.8145 2.4935L4.45043 4.7751H4.43519C3.59633 4.93552 2.85034 5.41014 2.34961 6.10202C3.10401 5.56543 4.00708 5.27766 4.93285 5.27885Z"
        fill={fill}
      />
      <path
        d="M21.183 6.49976H4.93298C4.07132 6.5007 3.24521 6.84341 2.63593 7.4527C2.02664 8.06199 1.68392 8.88809 1.68298 9.74975V19.4998C1.68392 20.3614 2.02664 21.1875 2.63593 21.7968C3.24521 22.4061 4.07132 22.7488 4.93298 22.7497H21.183C22.0446 22.7488 22.8707 22.4061 23.48 21.7968C24.0893 21.1875 24.432 20.3614 24.433 19.4998V9.74975C24.432 8.88809 24.0893 8.06199 23.48 7.4527C22.8707 6.84341 22.0446 6.5007 21.183 6.49976ZM18.7709 16.2498C18.4495 16.2498 18.1353 16.1544 17.8681 15.9759C17.6008 15.7973 17.3926 15.5435 17.2696 15.2466C17.1466 14.9497 17.1144 14.6229 17.1771 14.3077C17.2398 13.9925 17.3946 13.703 17.6218 13.4757C17.8491 13.2484 18.1386 13.0937 18.4538 13.031C18.7691 12.9683 19.0958 13.0005 19.3927 13.1234C19.6897 13.2464 19.9434 13.4547 20.122 13.722C20.3006 13.9892 20.3959 14.3034 20.3959 14.6248C20.3959 15.0557 20.2247 15.4691 19.9199 15.7738C19.6152 16.0785 19.2018 16.2498 18.7709 16.2498Z"
        fill={fill}
      />
      <path
        d="M1.70837 13.175V8.12231C1.70837 7.02188 2.31775 5.177 4.43279 4.77735C6.2279 4.44067 8.00525 4.44067 8.00525 4.44067C8.00525 4.44067 9.17322 5.25317 8.20837 5.25317C7.24353 5.25317 7.26892 6.49731 8.20837 6.49731C9.14783 6.49731 8.20837 7.69067 8.20837 7.69067L4.42517 11.9817L1.70837 13.175Z"
        fill={fill}
      />
    </svg>
  ),
  text: ({ fill }) => (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1605_281)">
        <path
          d="M12.539 6.56265H8.43744C8.06448 6.56265 7.70679 6.41449 7.44307 6.15077C7.17935 5.88705 7.03119 5.52936 7.03119 5.1564V1.05484C7.03119 1.02376 7.01884 0.993953 6.99686 0.971976C6.97489 0.949999 6.94508 0.937653 6.914 0.937653H4.21869C3.72141 0.937653 3.24449 1.1352 2.89286 1.48683C2.54123 1.83846 2.34369 2.31537 2.34369 2.81265V12.1876C2.34369 12.6849 2.54123 13.1618 2.89286 13.5135C3.24449 13.8651 3.72141 14.0626 4.21869 14.0626H10.7812C11.2785 14.0626 11.7554 13.8651 12.107 13.5135C12.4586 13.1618 12.6562 12.6849 12.6562 12.1876V6.67984C12.6562 6.64876 12.6438 6.61895 12.6219 6.59697C12.5999 6.575 12.5701 6.56265 12.539 6.56265ZM9.84369 11.2501H5.15619C5.03187 11.2501 4.91264 11.2008 4.82473 11.1129C4.73682 11.0249 4.68744 10.9057 4.68744 10.7814C4.68744 10.6571 4.73682 10.5379 4.82473 10.4499C4.91264 10.362 5.03187 10.3126 5.15619 10.3126H9.84369C9.96801 10.3126 10.0872 10.362 10.1751 10.4499C10.2631 10.5379 10.3124 10.6571 10.3124 10.7814C10.3124 10.9057 10.2631 11.0249 10.1751 11.1129C10.0872 11.2008 9.96801 11.2501 9.84369 11.2501ZM9.84369 8.9064H5.15619C5.03187 8.9064 4.91264 8.85701 4.82473 8.76911C4.73682 8.6812 4.68744 8.56197 4.68744 8.43765C4.68744 8.31333 4.73682 8.1941 4.82473 8.10619C4.91264 8.01829 5.03187 7.9689 5.15619 7.9689H9.84369C9.96801 7.9689 10.0872 8.01829 10.1751 8.10619C10.2631 8.1941 10.3124 8.31333 10.3124 8.43765C10.3124 8.56197 10.2631 8.6812 10.1751 8.76911C10.0872 8.85701 9.96801 8.9064 9.84369 8.9064Z"
          fill={fill}
        />
        <path
          d="M12.2818 5.526L8.06859 1.31282C8.0604 1.30467 8.04998 1.29913 8.03865 1.29689C8.02731 1.29465 8.01557 1.29581 8.00489 1.30022C7.99422 1.30464 7.98508 1.31211 7.97864 1.3217C7.9722 1.33129 7.96874 1.34257 7.96869 1.35412V5.15715C7.96869 5.28147 8.01807 5.4007 8.10598 5.48861C8.19389 5.57652 8.31312 5.6259 8.43744 5.6259H12.2405C12.252 5.62585 12.2633 5.62239 12.2729 5.61595C12.2825 5.60951 12.29 5.60037 12.2944 5.5897C12.2988 5.57902 12.2999 5.56728 12.2977 5.55594C12.2955 5.54461 12.2899 5.53419 12.2818 5.526Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_1605_281">
          <rect width="15" height="15" fill={fill} />
        </clipPath>
      </defs>
    </svg>
  ),
  back: () => (
    <svg
      width="10"
      height="16"
      viewBox="0 0 10 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.13072 0.269658C9.42362 0.562551 9.42362 1.03742 9.13072 1.33032L2.46105 7.99999L9.13072 14.6697C9.42362 14.9625 9.42362 15.4374 9.13072 15.7303C8.83783 16.0232 8.36295 16.0232 8.07006 15.7303L0.870061 8.53032C0.729408 8.38967 0.650391 8.1989 0.650391 7.99999C0.650391 7.80107 0.729408 7.61031 0.870061 7.46966L8.07006 0.269658C8.36295 -0.0232355 8.83783 -0.0232355 9.13072 0.269658Z"
        fill="#B0BAC9"
      />
    </svg>
  ),
  next: () => (
    <svg
      width="10"
      height="16"
      viewBox="0 0 10 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.870061 0.269658C0.577167 0.562551 0.577167 1.03742 0.870061 1.33032L7.53973 7.99999L0.870061 14.6697C0.577167 14.9625 0.577167 15.4374 0.870061 15.7303C1.16295 16.0232 1.63783 16.0232 1.93072 15.7303L9.13072 8.53032C9.27137 8.38967 9.35039 8.1989 9.35039 7.99999C9.35039 7.80107 9.27137 7.61031 9.13072 7.46966L1.93072 0.269658C1.63783 -0.0232355 1.16295 -0.0232355 0.870061 0.269658Z"
        fill="#B0BAC9"
      />
    </svg>
  ),
  "open-menu": ({ fill }) => (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M0 0H24V24H0z" fill="none" />
        <path d="M21 18v2H3v-2h18zM17.404 3.904L22 8.5l-4.596 4.596-1.414-1.414L19.172 8.5 15.99 5.318l1.414-1.414zM12 11v2H3v-2h9zm0-7v2H3V4h9z" />
      </g>
    </svg>
  ),
  "close-menu": ({ fill }) => (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M0 0H24V24H0z" fill="none" />
        <path d="M21 18v2H3v-2h18zM6.596 3.904L8.01 5.318 4.828 8.5l3.182 3.182-1.414 1.414L2 8.5l4.596-4.596zM21 11v2h-9v-2h9zm0-7v2h-9V4h9z" />
      </g>
    </svg>
  ),
  download: ({ fill }) => (
    <svg
      fill="none"
      height="24"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="7 10 12 15 17 10" />
      <line x1="12" x2="12" y1="15" y2="3" fill={fill} />
    </svg>
  ),
  print: ({ fill }) => (
    <svg
      viewBox="64 64 896 896"
      focusable="false"
      data-icon="printer"
      width="1em"
      height="1em"
      fill="currentColor"
      aria-hidden="true"
    >
      <path
        d="M820 436h-40c-4.4 0-8 3.6-8 8v40c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-40c0-4.4-3.6-8-8-8zm32-104H732V120c0-4.4-3.6-8-8-8H300c-4.4 0-8 3.6-8 8v212H172c-44.2 0-80 35.8-80 80v328c0 17.7 14.3 32 32 32h168v132c0 4.4 3.6 8 8 8h424c4.4 0 8-3.6 8-8V772h168c17.7 0 32-14.3 32-32V412c0-44.2-35.8-80-80-80zM360 180h304v152H360V180zm304 664H360V568h304v276zm200-140H732V500H292v204H160V412c0-6.6 5.4-12 12-12h680c6.6 0 12 5.4 12 12v292z"
        fill={fill}
      />
    </svg>
  ),
  "sort-up": ({ fill }) => (
    <svg
      width="7"
      height="4"
      viewBox="0 0 7 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.97217 3.33334L3.63883 1.0305e-05L0.305502 3.33334L6.97217 3.33334Z"
        fill={fill}
      />
    </svg>
  ),
  "sort-down": ({ fill }) => (
    <svg
      width="7"
      height="4"
      viewBox="0 0 7 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.305664 3.05176e-05L3.639 3.33336L6.97233 3.05176e-05H0.305664Z"
        fill={fill}
      />
    </svg>
  ),
  "full-screen": ({ fill }) => (
    <svg
      fill={fill}
      height="48"
      viewBox="0 0 48 48"
      width="48"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect fillOpacity="0.01" height="48" width="48" />
      <path
        d="M6 6L16 15.8995"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
      />
      <path
        d="M6 41.8995L16 32"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
      />
      <path
        d="M42.0001 41.8995L32.1006 32"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
      />
      <path
        d="M41.8995 6L32 15.8995"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
      />
      <path
        d="M33 6H42V15"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
      />
      <path
        d="M42 33V42H33"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
      />
      <path
        d="M15 42H6V33"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
      />
      <path
        d="M6 15V6H15"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
      />
    </svg>
  ),
  "zoom-in": ({ fill }) => (
    <svg
      fill="none"
      height="24"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="11" cy="11" r="8" />
      <line x1="21" x2="16.65" y1="21" y2="16.65" />
      <line x1="11" x2="11" y1="8" y2="14" fill={fill} />
      <line x1="8" x2="14" y1="11" y2="11" fill={fill} />
    </svg>
  ),
  "zoom-out": ({ fill }) => (
    <svg
      height="24"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="11" cy="11" r="8" fill="transparent" />
      <line x1="21" x2="16.65" y1="21" y2="16.65" fill={fill} />
      <line x1="8" x2="14" y1="11" y2="11" fill={fill} />
    </svg>
  ),
  refresh: ({ fill }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
      <path
        fill={fill || "currentColor"}
        d="M784.512 230.272v-50.56a32 32 0 1 1 64 0v149.056a32 32 0 0 1-32 32H667.52a32 32 0 1 1 0-64h92.992A320 320 0 1 0 524.8 833.152a320 320 0 0 0 320-320h64a384 384 0 0 1-384 384 384 384 0 0 1-384-384 384 384 0 0 1 643.712-282.88z"
      />
    </svg>
  ),
  close: ({ fill }) => (
    <svg
      height="512px"
      id="Layer_1"
      // style="enable-background:new 0 0 512 512;"
      version="1.1"
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M437.5,386.6L306.9,256l130.6-130.6c14.1-14.1,14.1-36.8,0-50.9c-14.1-14.1-36.8-14.1-50.9,0L256,205.1L125.4,74.5  c-14.1-14.1-36.8-14.1-50.9,0c-14.1,14.1-14.1,36.8,0,50.9L205.1,256L74.5,386.6c-14.1,14.1-14.1,36.8,0,50.9  c14.1,14.1,36.8,14.1,50.9,0L256,306.9l130.6,130.6c14.1,14.1,36.8,14.1,50.9,0C451.5,423.4,451.5,400.6,437.5,386.6z"
        fill={fill}
      />
    </svg>
  ),
  euro: ({ fill }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="800px"
      height="800px"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
        stroke={fill}
        strokeWidth="2"
      />
      <path
        d="M8 10.5H13"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 13.5H12"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 8C14.3732 7.37209 13.5941 7 12.7498 7C10.6788 7 9 9.23858 9 12C9 14.7614 10.6788 17 12.7498 17C13.5941 17 14.3732 16.6279 15 16"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  ),
  error: () => (
    <svg
      width="800px"
      height="800px"
      viewBox="0 0 512 512"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="add" fill="#ff0000" transform="translate(42.666667, 42.666667)">
          <path
            d="M213.333333,3.55271368e-14 C331.136,3.55271368e-14 426.666667,95.5306667 426.666667,213.333333 C426.666667,331.136 331.136,426.666667 213.333333,426.666667 C95.5306667,426.666667 3.55271368e-14,331.136 3.55271368e-14,213.333333 C3.55271368e-14,95.5306667 95.5306667,3.55271368e-14 213.333333,3.55271368e-14 Z M262.250667,134.250667 L213.333333,183.168 L164.416,134.250667 L134.250667,164.416 L183.168,213.333333 L134.250667,262.250667 L164.416,292.416 L213.333333,243.498667 L262.250667,292.416 L292.416,262.250667 L243.498667,213.333333 L292.416,164.416 L262.250667,134.250667 Z"
            id="Combined-Shape"
          ></path>
        </g>
      </g>
    </svg>
  ),
  success: () => (
    <svg
      width="800px"
      height="800px"
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#15d515"
        d="M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896zm-55.808 536.384-99.52-99.584a38.4 38.4 0 1 0-54.336 54.336l126.72 126.72a38.272 38.272 0 0 0 54.336 0l262.4-262.464a38.4 38.4 0 1 0-54.272-54.336L456.192 600.384z"
      />
    </svg>
  ),
  stripe: ({ fill }) => (
    <svg
      width="800px"
      height="800px"
      viewBox="0 0 128 128"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      role="img"
      className="iconify iconify--noto"
      preserveAspectRatio="xMidYMid meet"
    >
      <path
        d="M94.9 71.35c-8.08-7.63-21.82-13.99-30.91-18.2c-1.54-.71-2.93-1.35-4.11-1.92c-3.43-1.65-8.12-6.22-6.1-11.47c1.36-3.55 4.81-5.34 10.27-5.34c1.75 0 3.67.2 5.72.58c7.12 1.33 12.52 3.99 15.58 5.5c.38.19.82.21 1.22.07c.39-.15.72-.45.89-.84l7.01-15.81c.31-.69.07-1.51-.57-1.93c-4.94-3.28-17.27-8.15-30.97-8.15c-1.98 0-3.95.1-5.87.3c-10.92 1.12-21.86 4.03-27.92 17.64c-3.78 8.47-3.77 18.01.01 24.89c4.04 7.51 10.66 10.87 19.04 15.11l1.08.55c6.05 3.02 13.3 6.38 18.07 8.59c7.05 3.4 9.66 9.44 8.04 13.08c-2.61 5.87-8.38 7.16-18.36 4.33c-8.81-2.39-16.94-9.14-19.21-11.15c-.34-.3-.79-.44-1.25-.38c-.45.06-.85.32-1.1.69L24.6 104.14c-.41.63-.32 1.46.22 1.98c5.63 5.43 10.22 8.59 18.17 12.5c5.35 2.63 13.18 4.21 20.95 4.21c8.12 0 27.95-1.88 36.65-19.26c5.55-11.12 3.48-22.84-5.69-32.22z"
        fill={fill}
      />
    </svg>
  ),
  dollar: ({ fill }) => (
    <svg
      width="800px"
      height="800px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 3V21M15.679 6.63439C14.063 4.2691 7.94541 4.02196 7.94541 8.16745C7.94541 12.3129 16.7524 10.33 16.2439 15.2118C15.8199 19.2823 9.19299 19.3384 7.21094 16.0891"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  plus: ({ fill }) => (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15" cy="15" r="15" fill="#D9D9D9" />
      <rect x="13.5" y="9" width="3" height="12" rx="0.75" fill="white" />
      <rect x="9" y="13.5" width="12" height="3" rx="0.75" fill="white" />
    </svg>
  ),
  graph: ({ fill }) => (
    <svg
      width="15"
      height="15"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 9.2h3V19H5V9.2zM10.6 5h2.8v14h-2.8V5zm5.6 8H19v6h-2.8v-6z"
        fill={fill || "#2D3748"}
      />
    </svg>
  ),
  delete: ({ fill }) => (
    <svg
      width="15"
      height="15"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
        fill={fill || "#2D3748"}
      />
    </svg>
  ),
  lock: ({ fill }) => (
    <svg
      width="15"
      height="15"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
        fill={fill || "#2D3748"}
      />
    </svg>
  ),
  unlock: ({ fill }) => (
    <svg
      width="15"
      height="15"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h1.9c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2z"
        fill={fill || "#2D3748"}
      />
    </svg>
  ),
  rightButton: ({ fill }) => (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_266_782"
        maskType="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="2"
        width="12"
        height="9"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.7539 2.30094C12.0856 2.63917 12.0807 3.18267 11.743 3.51486L4.59722 10.5437L0.256526 6.27404C-0.0811977 5.94184 -0.0860865 5.39835 0.245606 5.06011C0.577299 4.72188 1.11997 4.71698 1.45769 5.04918L4.59722 8.13732L10.5418 2.29C10.8796 1.9578 11.4222 1.9627 11.7539 2.30094Z"
          fill="#006FFD"
        />
      </mask>
      <g mask="url(#mask0_266_782)">
        <rect x="0.000244141" width="11.9995" height="11.9995" fill="#EACEB3" />
      </g>
    </svg>
  ),
};

export default Icon;
